<style scoped>
.printPage p{
    font-size: 17px;
    font-weight: 600;
}
table{
    border-color:#bcbcbc;
    border-spacing: 0px;
    line-height: 30px;
    width: 100%;
    border-top: none;
    border-left: none;
    text-align: left;
}
table tr td{
    border-bottom: none;
    border-right: none;
    border-color:#bcbcbc;
    padding: 0 6px;
}
.tdBg{
    background:#f3f3f3;
}
.tdCenter{
    text-align: center;
}
</style>
<template>
  <div class="printPage">
    <el-dialog title="打印预览" :visible.sync="showPrintDialog" width="800px" :show-close='false' :close-on-click-modal="false">

      <!-- 会议任务申请 -->
      <div v-if="printType == 1" id="printBill">
        <p>会议任务申请</p>
        <table border="1px">
          <tr>
            <td class="tdBg">审批编号</td>
            <td colspan="5">{{printData.guid}}</td>
          </tr>
          <tr>
            <td class="tdBg">申请人</td>
            <td>{{printData.staffName}}</td>
            <td class="tdBg"  colspan="2">提交时间</td>
            <td>{{printData.createTime | getTime}}</td>
          </tr>
          <tr>
            <td class="tdBg">申请部门</td>
            <td>{{printData.organisationName}}</td>
            <td  class="tdBg" colspan="2">当前审核状态</td>
            <td>{{printData.approveState |filterApproveState}}</td>
          </tr>
          <tr>
            <td colspan="5" class="tdBg tdCenter">申请内容</td>
          </tr>
          <tr>
            <td class="tdBg" style="width:100px;">会议名称</td>
            <td>{{printData.projectName}}</td>
            <td class="tdBg" colspan="2" style="width:100px;">会议内容</td>
            <td>{{printData.applySubject}}</td>
          </tr>
          <tr>
            <td class="tdBg">费用金额</td>
            <td>{{printData.amount | numDigit}}</td>
            <td class="tdBg" colspan="2">发生日期</td>
            <td>{{printData.occurTime | getDate}}</td>
          </tr>
          <tr>
            <td class="tdBg">会议类别</td>
            <td colspan="5">{{printData.meetingTypeName}}</td>
          </tr>
          
          <tr>
            <td class="tdBg">学术计划</td>
            <td colspan="5">{{printData.isPlan=='Y'?'在当月内':'不在当月内'}}</td>
          </tr>
          <!-- <tr v-if="printData.franchiseeName">
            <td class="tdBg">参会主体</td>
            <td colspan="5">{{printData.franchiseeName}}</td>
          </tr> -->
          <tr v-if="printData.franchiseeName || printData.meetingBody">
            <td class="tdBg" v-if="printData.meetingBodyType">主体类型</td>
            <td  v-if="printData.meetingBodyType">{{printData.meetingBodyType | meetingBodyType}}</td>
            <td class="tdBg" colspan="2">参会主体</td>
            <td >{{printData.franchiseeName || printData.meetingBody}}</td>
          </tr>
          <!-- <tr>
            <td class="tdBg">项目名称</td>
            <td colspan="3">{{printData.projectName}}</td>
          </tr> -->
          <tr>
            <td colspan="8" class="tdBg tdCenter">审批流程</td>
          </tr>
          <tr>
            <td class="tdBg">审批节点</td>
            <td class="tdBg">审批人</td>
 
            <td class="tdBg">操作记录</td>
            <td class="tdBg" colspan="2">备注</td>

          </tr>
          <tr v-for="(item,index) in approvalList" :key="index" v-show="item.approveStaffGuid">
            <td>审批人</td>
            <td>{{item.approveStaffName}}</td>
        
            <td>{{item.nodeState|filterApproveState}} &nbsp;{{item.updateTime|getTime}}</td>
            <td colspan="2">{{item.approveSuggest}}</td>

          </tr>
          <tr v-if="sendCopy">
            <td>抄送人</td>
            <td>{{sendCopy}}</td>
            <td>{{printData.approveState|filterApproveState}} &nbsp; {{printData.approveTime|getTime}}</td>
            <td colspan="2"></td>
          </tr>
        </table>
      </div>

      <!-- 线上会议执行 -->
      <div v-if="printType == 2" id="printBill">
        <p>线上会议执行</p>
        <table border="1px">
          <tr>
            <td class="tdBg">审批编号</td>
            <td colspan="3">{{printData.guid}}</td>
          </tr>
          <tr>
            <td class="tdBg">申请人</td>
            <td>{{printData.staffName}}</td>
            <td class="tdBg">提交时间</td>
            <td>{{printData.createTime | getTime}}</td>
          </tr>
          <tr>
            <td class="tdBg">申请部门</td>
            <td>{{printData.organisationName}}</td>
            <td class="tdBg">当前审核状态</td>
            <td>{{printData.approveState |filterApproveState}}</td>
          </tr>
          <tr>
            <td colspan="4" class="tdBg tdCenter">申请内容</td>
          </tr>
          <tr>
            <td class="tdBg">会议主题</td>
            <td colspan="3">{{printData.meetingSubject}}</td>
          </tr>
          <tr>
            <td class="tdBg">会议类型</td>
            <td>{{printData.meetingType | meetingType}}</td>
            <td class="tdBg">安全级别</td>
            <td>{{printData.safeLevel | safeLevel}}</td>
          </tr>
          <tr>
            <td class="tdBg">开始时间</td>
            <td>{{printData.startTime | getTime}}</td>
            <td class="tdBg">结束时间</td>
            <td>{{printData.endTime | getTime}}</td>
          </tr>
          <tr>
            <td class="tdBg">会议方案</td>
            <td colspan="3">{{caCodeToDesc(printData.meetingPlan)}}</td>
          </tr>
          <tr>
            <td class="tdBg">参会人数</td>
            <td colspan="3">{{printData.peopleNum}}</td>
          </tr>
          <tr>
            <td class="tdBg" style="width:100px;">会议议程</td>
            <td colspan="3" v-html="changeEnter(printData.meetingAgenda)"></td>
          </tr>
          <tr>
            <td class="tdBg">会议目的</td>
            <td colspan="3">{{printData.meetingPrupose}}</td>
          </tr>
          <tr>
            <td class="tdBg">预期效果</td>
            <td colspan="3">{{printData.desiredResult}}</td>
          </tr>
          <tr>
            <td class="tdBg">讲者介绍</td>
            <td colspan="3">{{printData.speakerIntroduction}}</td>
          </tr>
          <tr>
            <td class="tdBg">会议负责人</td>
            <td>{{printData.leader}}</td>
            <td class="tdBg">负责人电话</td>
            <td>{{printData.leaderMobileNo}}</td>
          </tr>
          <tr>
            <td colspan="4" class="tdBg tdCenter">审批流程</td>
          </tr>
          <tr>
            <td class="tdBg">审批节点</td>
            <td class="tdBg">审批人</td>
            <td class="tdBg">操作记录</td>
            <td class="tdBg">备注</td>
          </tr>
          <tr v-for="(item,index) in approvalList" :key="index" v-show="item.approveStaffGuid">
            <td>审批人</td>
            <td>{{item.approveStaffName}}</td>
            <td>{{item.nodeState|filterApproveState}} &nbsp;&nbsp;&nbsp; {{item.updateTime|getTime}}</td>
            <td>{{item.approveSuggest}}</td>
          </tr>
          <tr v-if="sendCopy">
            <td>抄送人</td>
            <td>{{sendCopy}}</td>
            <td>{{printData.approveState|filterApproveState}} &nbsp;&nbsp;&nbsp; {{printData.approveTime|getTime}}</td>
            <td></td>
          </tr>
        </table>
      </div>
      <!-- 会议费用报销 -->
      <div v-if="printType == 3" id="printBill">
        <p>会议任务总结</p>
        <table border="1px">
          <tr>
            <td class="tdBg">审批编号</td>
            <td colspan="3">{{printData.guid}}</td>
          </tr>
          <tr>
            <td class="tdBg">申请人</td>
            <td>{{printData.staffName}}</td>
            <td class="tdBg">提交时间</td>
            <td>{{printData.createTime | getTime}}</td>
          </tr>
          <tr>
            <td class="tdBg">申请部门</td>
            <td>{{printData.organisationName}}</td>
            <td class="tdBg">当前审核状态</td>
            <td>{{printData.approveState |filterApproveState}}</td>
          </tr>
          <tr>
            <td colspan="4" class="tdBg tdCenter">申请内容</td>
          </tr>
          <tr>
            <td class="tdBg">参会人数</td>
            <td >{{printData.peopleNum || 0}}</td>
            <td class="tdBg">医生人数</td>
            <td >{{printData.doctorNum || 0}}</td>
          </tr>
          <tr>
            <td class="tdBg">讲者姓名</td>
            <td colspan="3">{{printData.speakerName}}</td>
          </tr>
          <tr>
            <td class="tdBg">参会方式</td>
            <td colspan="3">{{ printData.joinWay==1?'线上':printData.joinWay==2?'线下':'-'}}</td>
          </tr>
          <tr>
            <td class="tdBg">会议组织人</td>
            <td colspan="3">{{getDocorName(printData.realExpenseUserName)}}</td>
          </tr>

          <tr>
            <td class="tdBg">会议主题</td>
            <td colspan="3">{{printData.projectName}}</td>
          </tr>
          <tr>
            <td class="tdBg" style="width:100px;">会议内容</td>
            <td colspan="3">{{printData.expenseSubject}}</td>
          </tr>

   
       
          <tr>
            <td class="tdBg">会议类别</td>
            <td colspan="3">{{printData.meetingTypeName}}</td>
          </tr>
            
          <!-- <tr v-if="printData.franchiseeName">
            <td class="tdBg">参会主体</td>
            <td colspan="3">{{printData.franchiseeName}}</td>
          </tr> -->
          <tr v-if="printData.franchiseeName || printData.meetingBody">
            <td class="tdBg" v-if="printData.meetingBodyType">主体类型</td>
            <td  v-if="printData.meetingBodyType">{{printData.meetingBodyType | meetingBodyType}}</td>
            <td class="tdBg" >参会主体</td>
            <td >{{printData.franchiseeName || printData.meetingBody}}</td>
          </tr>
          
          <tr v-if="printData.deptInfo">
            <td class="tdBg">科室名称</td>
            <td colspan="3">{{getDocorName(printData.deptInfo)}}</td>
          </tr>
            <tr v-if="printData.goodsInfo">
            <td class="tdBg">产品名称</td>
            <td colspan="3" v-html="getGoodsName(printData.goodsInfo)"></td>
          </tr>
          <tr>
            <td class="tdBg">实际会议费用</td>
            <td>{{printData.amount | numDigit}}</td>
            <td class="tdBg">发生日期</td>
            <td>{{printData.occurTime | getDate}}</td>
          </tr>
          <tr v-if="printData.costInfo">
            <td class="tdBg">费用明细</td>
            <td colspan="3">{{getAmount(printData.costInfo)}}</td>
          </tr>
         <tr v-if="printData.memo">
            <td class="tdBg">备注</td>
            <td colspan="3">{{printData.memo}}</td>
          </tr>

          <tr>
            <td colspan="4" class="tdBg tdCenter">审批流程</td>
          </tr>
          <tr>
            <td class="tdBg">审批节点</td>
            <td class="tdBg">审批人</td>
            <td class="tdBg">操作记录</td>
            <td class="tdBg">备注</td>
          </tr>
          <tr v-for="(item,index) in approvalList" :key="index" v-show="item.approveStaffGuid">
            <td>审批人</td>
            <td>{{item.approveStaffName}}</td>
            <td>{{item.nodeState|filterApproveState}} &nbsp;&nbsp;&nbsp; {{item.updateTime|getTime}}</td>
            <td>{{item.approveSuggest}}</td>
          </tr>
          <tr v-if="sendCopy">
            <td>抄送人</td>
            <td>{{sendCopy}}</td>
            <td>{{printData.approveState|filterApproveState}} &nbsp;&nbsp;&nbsp; {{printData.approveTime|getTime}}</td>
            <td></td>
          </tr>
        </table>
      </div>
      <!-- 学术活动 -->
      <div v-if="printType == 4" id="printBill">
        <p>【{{printData.tenantName}}】学术活动</p>
        <table border="1px">
          <tr>
            <td class="tdBg">审批编号</td>
            <td colspan="3">{{printData.guid}}</td>
          </tr>
          <tr>
            <td class="tdBg">申请人</td>
            <td>{{printData.staffName}}</td>
            <td class="tdBg">提交时间</td>
            <td>{{printData.createTime | getTime}}</td>
          </tr>
          <tr>
            <td class="tdBg">申请部门</td>
            <td>{{printData.organisationName}}</td>
            <td class="tdBg">当前审核状态</td>
            <td>{{printData.approveState |filterApproveState}}</td>
          </tr>
          <tr>
            <td colspan="4" class="tdBg tdCenter">申请内容</td>
          </tr>
          <tr>
            <td class="tdBg">会议计划</td>
            <td>{{printData.academicActivityPlanTitle}}</td>
            <td class="tdBg"></td>
            <td></td>
          </tr>
          <tr>
            <td class="tdBg">计划费用</td>
            <td>{{printData.planCost}}</td>
            <td class="tdBg">实际费用</td>
            <td>{{printData.realCost}}</td>
          </tr>
          <tr>
            <td colspan="4" class="tdBg tdCenter">审批流程</td>
          </tr>
          <tr>
            <td class="tdBg">审批节点</td>
            <td class="tdBg">审批人</td>
            <td class="tdBg">操作记录</td>
            <td class="tdBg">备注</td>
          </tr>
          <tr v-for="(item,index) in approvalList" :key="index" v-show="item.approveStaffGuid">
            <td>审批人</td>
            <td>{{item.approveStaffName}}</td>
            <td>{{item.nodeState|filterApproveState}} &nbsp;&nbsp;&nbsp; {{item.updateTime|getTime}}</td>
            <td>{{item.approveSuggest}}</td>
          </tr>
          <tr v-if="sendCopy">
            <td>抄送人</td>
            <td>{{sendCopy}}</td>
            <td>{{printData.approveState|filterApproveState}} &nbsp;&nbsp;&nbsp; {{printData.approveTime|getTime}}</td>
            <td></td>
          </tr>
        </table>
      </div>
      <!--  新客户申请 -->
      <div v-if="printType == 5" id="printBill">
        <p>【{{printData.tenantName}}】 新客户申请</p>
        <table border="1px">
          <!-- <tr>
            <td class="tdBg">审批编号</td>
            <td colspan="3">{{printData.guid}}</td>
          </tr> -->
          <tr>
            <td class="tdBg">申请人</td>
            <td>{{printData.createUserName}}</td>
            <td class="tdBg">提交时间</td>
            <td>{{printData.approvalSubmitTime | getTime}}</td>
          </tr>
          <tr>
            <td class="tdBg">申请部门</td>
            <td>{{printData.organisationName}}</td>
            <td class="tdBg">当前审核状态</td>
            <td>{{printData.approvalState | filterApproveState}}</td>
          </tr>
          <tr>
            <td colspan="4" class="tdBg tdCenter">申请内容</td>
          </tr>
          <tr>
            <td class="tdBg">客户类型</td>
            <td>{{printData.terminalProperty}}</td>
            <td class="tdBg">客户名称</td>
            <td>{{printData.customerName}}</td>
          </tr>
          <tr>
            <td class="tdBg">所在区域</td>
            <td>{{printData.venue}}</td>
            <td class="tdBg">详细地址</td>
            <td>{{printData.address}}</td>
          </tr>
          <tr v-show="printData.terminalProperty=='连锁总部'">
            <td class="tdBg">直营门店数量</td>
            <td>{{printData.directStoresNum}}</td>
            <td class="tdBg">加盟门店数量</td>
            <td>{{printData.affiliatedShopNum}}</td>
          </tr>
          <tr>
            <td class="tdBg">药店联系人</td>
            <td>{{printData.contacts}}</td>
            <td class="tdBg">手机号码</td>
            <td>{{printData.contactTel}}</td>
          </tr>
          <tr v-show="printData.terminalProperty!=='连锁总部'">
            <td class="tdBg">经营时长(年)</td>
            <td>{{printData.manageDuration}}</td>
            <td class="tdBg">面积(m2)</td>
            <td>{{printData.areaMeasure}}</td>
          </tr>
          <tr>
            <td class="tdBg">建档时间</td>
            <td>{{printData.inputDate | getDate}}</td>
            <td class="tdBg"></td>
            <td></td>
          </tr>
          <tr>
            <td colspan="4" class="tdBg tdCenter">审批流程</td>
          </tr>
          <tr>
            <td class="tdBg">审批节点</td>
            <td class="tdBg">审批人</td>
            <td class="tdBg">操作记录</td>
            <td class="tdBg">备注</td>
          </tr>
          <tr v-for="(item,index) in approvalList" :key="index" v-show="item.approveStaffGuid">
            <td>审批人</td>
            <td>{{item.approveStaffName}}</td>
            <td>{{item.nodeState|filterApproveState}} &nbsp;&nbsp;&nbsp; {{item.updateTime|getTime}}</td>
            <td>{{item.approveSuggest}}</td>
          </tr>
          <tr v-if="sendCopy">
            <td>抄送人</td>
            <td>{{sendCopy}}</td>
            <td>{{printData.approveState|filterApproveState}} &nbsp;&nbsp;&nbsp; {{printData.approveTime|getTime}}</td>
            <td></td>
          </tr>
        </table>
      </div>
      <!--  客户档案修改 -->
      <div v-if="printType == 6" id="printBill">
        <p>【{{printData.tenantName}}】 客户档案修改</p>
        <table border="1px">
          <tr>
            <td class="tdBg">审批编号</td>
            <td colspan="3">{{printData.guid}}</td>
          </tr>
          <tr>
            <td class="tdBg">申请人</td>
            <td>{{printData.createUserName}}</td>
            <td class="tdBg">提交时间</td>
            <td>{{printData.approvalSubmitTime | getTime}}</td>
          </tr>
          <tr>
            <td class="tdBg">申请部门</td>
            <td>{{printData.organisationName}}</td>
            <td class="tdBg">当前审核状态</td>
            <td>{{printData.approvalState |filterApproveState}}</td>
          </tr>
          <tr>
            <td colspan="4" class="tdBg tdCenter">申请内容</td>
          </tr>
          <tr>
            <td class="tdBg">客户类型</td>
            <td>{{printData.terminalProperty}}</td>
            <td class="tdBg">客户名称</td>
            <td>{{printData.customerName}}</td>
          </tr>
          <tr>
            <td class="tdBg">所在区域</td>
            <td>{{printData.venue}}</td>
            <td class="tdBg">详细地址</td>
            <td>{{printData.address}}</td>
          </tr>
          <tr v-show="printData.terminalProperty=='连锁总部'">
            <td class="tdBg">直营门店数量</td>
            <td>{{printData.directStoresNum}}</td>
            <td class="tdBg">加盟门店数量</td>
            <td>{{printData.affiliatedShopNum}}</td>
          </tr>
          <tr>
            <td class="tdBg">药店联系人</td>
            <td>{{printData.contacts}}</td>
            <td class="tdBg">手机号码</td>
            <td>{{printData.contactTel}}</td>
          </tr>
          <tr v-show="printData.terminalProperty !=='连锁总部'">
            <td class="tdBg">经营时长(年)</td>
            <td>{{printData.manageDuration}}</td>
            <td class="tdBg">面积(m2)</td>
            <td>{{printData.areaMeasure}}</td>
          </tr>
          <tr>
            <td class="tdBg">建档时间</td>
            <td>{{printData.inputDate | getDate}}</td>
            <td class="tdBg"></td>
            <td></td>
            <!-- <td>{{printData.level == 'N'?'暂无等级':(printData.level)}}</td> -->
          </tr>
          <tr>
            <td colspan="4" class="tdBg tdCenter">审批流程</td>
          </tr>
          <tr>
            <td class="tdBg">审批节点</td>
            <td class="tdBg">审批人</td>
            <td class="tdBg">操作记录</td>
            <td class="tdBg">备注</td>
          </tr>
          <tr v-for="(item,index) in approvalList" :key="index" v-show="item.approveStaffGuid">
            <td>审批人</td>
            <td>{{item.approveStaffName}}</td>
            <td>{{item.nodeState|filterApproveState}} &nbsp;&nbsp;&nbsp; {{item.updateTime|getTime}}</td>
            <td>{{item.approveSuggest}}</td>
          </tr>
          <tr v-if="sendCopy">
            <td>抄送人</td>
            <td>{{sendCopy}}</td>
            <td>{{printData.approveState|filterApproveState}} &nbsp;&nbsp;&nbsp; {{printData.approveTime|getTime}}</td>
            <td></td>
          </tr>
        </table>
      </div>
      <!-- 变更客户等级 -->
      <div v-if="printType == 7" id="printBill">
        <p>【{{printData.tenantName}}】 变更客户等级</p>
        <table border="1px">
          <!-- <tr>
            <td class="tdBg">审批编号</td>
            <td colspan="3">{{printData.guid}}</td>
          </tr> -->
          <tr>
            <td class="tdBg">申请人</td>
            <td>{{printData.createUserName}}</td>
            <td class="tdBg">提交时间</td>
            <td>{{printData.approvalSubmitTime | getTime}}</td>
          </tr>
          <tr>
            <td class="tdBg">申请部门</td>
            <td>{{printData.organisationName}}</td>
            <td class="tdBg">当前审核状态</td>
            <td>{{printData.approvalState |filterApproveState}}</td>
          </tr>
          <tr>
            <td colspan="4" class="tdBg tdCenter">申请内容</td>
          </tr>
          <tr>
            <td class="tdBg">客户名称</td>
            <td colspan="3">{{printData.customerName}}</td>
          </tr>
          <tr>
            <td class="tdBg">原客户等级</td>
            <td>{{printData.originalLevel}}类客户</td>
            <td class="tdBg">新客户等级</td>
            <td>{{printData.newLevel}}类客户</td>
          </tr>
          <tr>
            <td class="tdBg">变更原因</td>
            <td colspan="3">{{printData.changeCause}}</td>
          </tr>
          <tr>
            <td colspan="4" class="tdBg tdCenter">审批流程</td>
          </tr>
          <tr>
            <td class="tdBg">审批节点</td>
            <td class="tdBg">审批人</td>
            <td class="tdBg">操作记录</td>
            <td class="tdBg">备注</td>
          </tr>
          <tr v-for="(item,index) in approvalList" :key="index" v-show="item.approveStaffGuid">
            <td>审批人</td>
            <td>{{item.approveStaffName}}</td>
            <td>{{item.nodeState|filterApproveState}} &nbsp;&nbsp;&nbsp; {{item.updateTime|getTime}}</td>
            <td>{{item.approveSuggest}}</td>
          </tr>
          <tr v-if="sendCopy">
            <td>抄送人</td>
            <td>{{sendCopy}}</td>
            <td>{{printData.approveState|filterApproveState}} &nbsp;&nbsp;&nbsp; {{printData.approveTime|getTime}}</td>
            <td></td>
          </tr>
        </table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closePrint" style="color: #4fa1a4;">取 消</el-button>
        <el-button size="small" type="primary" @click="billPrintClick" style="color:#fff">打 印</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
  import print from 'print-js'
  export default {
    name: 'printPage',
    props: {
      showPrintDialog: {
        type: Boolean,
        default: false
      },
      printType: { //内容类型
        type: Number,
        default: 1
      },
      printData: { //流程内容
        type: Object,
        default: {}
      },
      approvalList: {  //审批流程节点
        type: Array,
        default: []
      }
    },
    filters: {
      filterApproveState(value) {
        let str = ''
        switch (value) {
          case 'N':
            str = '审批中';
            break;
          case 'A':
            str = '';
            break;
          case 'Y':
            str = '已通过';
            break;
          case 'R':
            str = '已驳回';
            break;
          case 'C':
            str = '已撤销';
            break;
        }
        return str
      }
    },
    data() {
      return {
        sendCopy: ''
      }
    },
    watch: {
      approvalList(newVal) {
        if (newVal.length) {
          let cosArr = JSON.parse(newVal[0].ccGuids)
          if (cosArr.length) {
            this.sendCopy = cosArr[0].name
          }
        }
      }
    },
    created() {
    },
    mounted() {
      if (this.approvalList.length) {
        let cosArr = JSON.parse(this.approvalList[0].ccGuids)
        if (cosArr.length) {
          this.sendCopy = cosArr[0].name
        }
      }
    },
    methods: {
        fmoney(num) {
        if (!num) {
          return "0.00";
        }
        num = num.toString().replace(/\$|\,/g, "");
        if (isNaN(num)) num = "0";
        var sign = num == (num = Math.abs(num));
        num = Math.floor(num * 100 + 0.50000000001);
        var cents = num % 100;
        num = Math.floor(num / 100).toString();
        if (cents < 10) cents = "0" + cents;
        for (var i = 0; i < Math.floor((num.length - (1 + i)) / 3); i++)
          num =
            num.substring(0, num.length - (4 * i + 3)) +
            "," +
            num.substring(num.length - (4 * i + 3));
        return (sign ? "" : "-") + num + "." + cents;
      },
      getAmount(res) {
        if (!res) return '-';
        var list = [];
        var res = JSON.parse(res);
        res.forEach((item, index) => {
          list.push(`${item.costTypeName}${this.fmoney(item.costAmount)}元`);
        });
        return list.join("、");


      },
      getGoodsName(res) {
        if (!res) return ;
        var list = [];
        var res = JSON.parse(res);
        res.forEach((item, index) => {
          list.push(`${item.name}<span style="color:#9F9F9F;font-size:14px !important;">(${item.goodsSpec})</span>`);
        });
        return list.join("、");
      },
      getDocorName(res) {
        if (!res) return;
        if (res.indexOf('name') > -1) {
          var list = [];
          var res = JSON.parse(res);
          if (res.length >= 2) {
            res.forEach((item, index) => {
              list.push(item.name);
            });
            return list.join("、");
          } else {
            return res[0].name;
          }
        } else {
          return res;
        }

      },
      //关闭打印
      closePrint() {
        this.$emit('closePrint')
      },
      billPrintClick() {
        let str = this.printType == 1 ? '会议费用申请' : this.printType == 2 ? '线上会议执行' : this.printType == 3 ? '会议费用报销' : '学术活动'
        const style = '@page {margin:0 10mm};'//打印时去掉眉页眉尾
        printJS({
          printable: 'printBill',// 标签元素id
          type: 'html',
          header: '',
          documentTitle: str,
          targetStyles: ['*'],
          // style
        });
        //各个配置项
        //printable:要打印的id。
        //type:可以是 html 、pdf、 json 等。
        //properties:是打印json时所需要的数据属性。
        //gridHeaderStyle和gridStyle都是打印json时可选的样式。
        //repeatTableHeader:在打印JSON数据时使用。设置为时false，数据表标题将仅在第一页显示。
        //scanStyles:设置为false时，库将不处理应用于正在打印的html的样式。使用css参数时很有用，此时自己设置的原来想要打印的样式就会失效，在打印预览时可以看到效果
        //targetStyles: [’*’],这样设置继承了页面要打印元素原有的css属性。
        //style:传入自定义样式的字符串，使用在要打印的html页面 也就是纸上的样子。
        //ignoreElements：传入要打印的div中的子元素id，使其不打印。非常好用
        this.closePrint()
      },
      // 处理数据
      caCodeToDesc(listStr) {
        if (listStr != '') {

          listStr = listStr.replace(/\"/g, '').replace(/[\\]/g, '').replace(/\[/g, '').replace(/\]/g, '').replace(/\,/g, '；');
          console.log(listStr)
          return listStr;
        }
      },
      changeEnter(content) {
        if (content == '' || content == null) {
          return '无';
        } else {
          content = content.replace(/\n/g, "</br>");
          return content;
        }
      },
    }
  }
</script>